import { Controller } from "@hotwired/stimulus"

// Wraps a native <details> element used as a popover menu. Closes
// the menu when the user clicks outside of it or presses Escape.
// Native <details> keeps itself open on outside clicks — this
// controller fixes that.
export default class extends Controller {
  connect() {
    this._onDocClick = (e) => {
      if (!this.element.contains(e.target) && this.element.open) {
        this.element.open = false
      }
    }
    this._onEsc = (e) => {
      if (e.key === "Escape" && this.element.open) this.element.open = false
    }
    document.addEventListener("click", this._onDocClick)
    document.addEventListener("keydown", this._onEsc)
  }

  disconnect() {
    document.removeEventListener("click", this._onDocClick)
    document.removeEventListener("keydown", this._onEsc)
  }
}
